"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WizardControl = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../ui");
var _utils = require("../../../../utils");
var _WizardControlStep = require("./WizardControlStep");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var WizardControl = (0, _styledComponents.default)(function (props) {
  return /*#__PURE__*/_react.default.createElement(_ui.WizardControl, _extends({
    stepComponent: _WizardControlStep.WizardControlStep
  }, props));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0 0 32px;\n  ", "\n"])), _utils.mediaQuery.lessThan('sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 15px 30px;\n"]))));
exports.WizardControl = WizardControl;